export default "__VITE_ASSET__3a949aec__"